import React, { useEffect, useMemo, useRef, useState }  from "react";
import * as S from "./Toolbar.style";
import { useTranslation } from "react-i18next";
import Popup from "reactjs-popup";
// Assets
const sidebarImg = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/florence-health.svg`;
const notificationSoundMp3 = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaia-sounds/notificationSound.mp3`;
const defaultDoctor = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaImgDefault/default-doctor.png`;

function Toolbar() { 
  
  const { t, i18n: { language } }= useTranslation("global");

  const container = useRef(null);
  const textInput = useRef(null);
  const [inputText, setInputText] = useState('');
  const [activeinput, setActiveinput] = useState(false);  

  const [medicalRecordsActived, setMedicalRecordsActived] = useState(false);

  const activeInput = () => {
    textInput.current.focus(); 
    setActiveinput(true);
  } 

  return (
    <S.Toolbar>
      <div className="toolbar">
        <div className="toolbar__left">
          {
            true 
            ? <div className="patient-selection">
              <div className="patient-selection__img">
                <img src={"https://vignette.wikia.nocookie.net/rickemorty/images/d/dc/4469093-screen_shot_2015-03-25_at_5.13.24_pm_copy.jpg/revision/latest?cb=20170918192423&path-prefix=pt-br"} alt="" className="patient-img" />
              </div>
              <div className="item-selected">
                <div className="item-selected__label">
                  ~Paciente
                  <i className="item-selected__icon icon zaia-i-refresh"></i>
                </div>
                <div className="item-selected__name">Dante Armada</div>
              </div>
            </div>
            : null
          }
          <div className="toolbar__separator"></div>
          <button className="toolbar__button">
            <div className="toolbar__button-text">
              ~Nuevo
            </div>
          </button>
          <div className="toolbar__separator"></div>
          <button className="toolbar__button">
            <i className="toolbar__button-icon toolbar__button-icon--plus icon zaia-i-add-2"></i>
          </button>
        </div>
        <div className="toolbar__center">
          <div className="searcher-container">
            <div className="searcher-content" ref={container} onClick={() => activeInput()}>
              <i className="searcher-content__icon icon zaia-i-search"></i>
              <div className="searcher-input">
                <input
                  className="searcher-input__input"
                  type="text"
                  onChange={(event) => setInputText(event.target.value)}
                  value={inputText}
                  ref={textInput} 
                  placeholder={t("globally.search")}
                />
                <i className="searcher-input__icon icon zaia-search"/>
              </div>
            </div>
          </div>
        </div>
        <div className="toolbar__right">
          <button className={`toolbar__button ${medicalRecordsActived ? "toolbar__button--active" : ""}`}
            onClick={() => setMedicalRecordsActived(!medicalRecordsActived)}
          >
            <i className="toolbar__button-icon toolbar__button-icon--clock icon zaia-i-reverse-clocl"></i>
          </button>
          <div className="toolbar__separator"></div>
          <Popup
            trigger={
              <div className="item-selected">
                <div className="item-selected__label">
                  ~Vista
                  <i className="item-selected__icon icon zaia-i-refresh"></i>
                </div>
                <div className="item-selected__name">~Historial clinical general</div>
              </div>
            }
            keepTooltipInside
            position={"bottom"}
          >
            <S.PopUpItemSelected>
              <div className="title">~Seleccionar vista</div>
              <div className="separator"></div>
              <div className="item">
                <div className={`item__title ${true && "item__title--selected"}`}>Historia clínica General</div>
                {
                  true &&
                  <div className="item__selected">Vista seleccionada</div>
                }
              </div>
              <div className="item">
                <div className="item__title">Historia clínica Enfermeria</div>
              </div>
              <div className="item">
                <div className="item__title">Historia clínica Cáncer de prostata</div>
              </div>
              <div className="item">
                <div className="item__title">Registrar / enviar medicamentos</div>
              </div>
            </S.PopUpItemSelected>
          </Popup>
          <div className="toolbar__separator"></div>
          <Popup
            trigger={
              <div className="item-selected">
                <div className="item-selected__label">
                  ~Sección
                  <i className="item-selected__icon icon zaia-i-refresh"></i>
                </div>
                <div className="item-selected__name">~Historia clínica</div>
              </div>
            }
            keepTooltipInside
            position={"bottom"}
          >
            <S.PopUpItemSelected>
              <div className="title">~Seleccionar vista</div>
              <div className="separator"></div>
              <div className="item">
                <div className="item__title">Historia clínica</div>
                {
                  true &&
                  <div className="item__selected">Vista seleccionada</div>
                }
              </div>
              <div className="item">
                <div className="item__title">Salud</div>
              </div>
              <div className="item">
                <div className="item__title">Outcomes</div>
              </div>
              <div className="item">
                <div className="item__title">Encuestas</div>
              </div>
            </S.PopUpItemSelected>
          </Popup>
        </div>
      </div>
    </S.Toolbar>
  );
}

export default Toolbar;
